import * as React from 'react'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import { ActivityDetailsHeader } from './ActivityDetailsHeader'
import { ActivityDetailsContent } from './ActivityDetailsContent'
import { ActivityDetailsActions } from './ActivityDetailsActions'
import { useData, useInitValues } from './hooks'
import { Formik } from 'formik'
import { ENTITY_TYPES } from '@sales-center/common'
import { useActivityData } from '../../hooks'
import { ActivityStatusSelect } from '../ActivityStatusSelect'

type Props = {
  entityId: number
  entityType: ENTITY_TYPES
  salesTeamId?: number
  ownerId?: string | null
}

export function ActivityDetails(props: Props) {
  const { entityId, entityType } = props
  const { currentActivity, title } = useData()
  const { updateDeleteEnabled } = useActivityData({ activity: currentActivity })
  const initValues = useInitValues(currentActivity)

  return (
    <Formik initialValues={initValues} onSubmit={() => {}}>
      <Paper>
        <Stack padding={2} width={355}>
          <ActivityDetailsHeader
            title={title}
            activity={currentActivity}
            entityId={entityId}
            entityType={entityType}
          />
          <ActivityDetailsContent current={currentActivity} />
          {updateDeleteEnabled ? (
            <>
              <ActivityStatusSelect id={currentActivity?.id || -1} />
              <ActivityDetailsActions
                id={currentActivity?.id || -1}
                {...props}
              />
            </>
          ) : null}
        </Stack>
      </Paper>
    </Formik>
  )
}
